<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave?.id ? "Modification "+title : "Enregistrement "+title}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                <div class="row">
                    <div class="col-md-10">
                        <div class="row">
                            <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Filiale :
                                    <span class="required_champs">*</span>
                                </label>
                                <ng-select disabled [(ngModel)]="filiale_id" (change)="load_filiale_data()"
                                    [disabled]="true" placeholder="Choisissez " name="filiale_id"
                                    id="filiale_id" [multiple]="false" [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsFiliale" [value]="item.id">{{ item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div> -->
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label (click)="onPenDetailModal('','garant')"
                                    [ngClass]="{'isSelectedItem':itemToSave.garant_id}">Garant :
                                    <span class="required_champs">*</span>
                                </label>
                                <ng-select
                                    [disabled]="isAutoFill || itemToSave.id || itemToSave.is_detail_mode || itemToSave.isAddBeneficiaire"
                                    (change)="onSelectGarant()" [(ngModel)]="itemToSave.garant_id"
                                    placeholder="Choisissez " name="garant_id" id="garant_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsGarant" [value]="item.id">{{ item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label (click)="onPenDetailModal('','police')"
                                    [ngClass]="{'isSelectedItem':itemToSave.police_id}">Police :
                                    <span class="required_champs">*</span>
                                </label>
                                <ng-select [disabled]="isAutoFill || itemToSave.id || itemToSave.is_detail_mode"
                                    (change)="onSelectPolice()" [(ngModel)]="itemToSave.police_id"
                                    placeholder="Choisissez " name="police_id" id="police_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsPolice" [value]="item.id">{{ item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label (click)="onPenDetailModal('','college')"
                                    [ngClass]="{'isSelectedItem':itemToSave.college_id}">Collège :
                                    <span class="required_champs">*</span>
                                </label>
                                <ng-select [disabled]="isAutoFill || itemToSave.id || itemToSave.is_detail_mode"
                                    (change)="onSelectCollege()" [(ngModel)]="itemToSave.college_id"
                                    placeholder="Choisissez " name="college_id" id="college_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsCollege" [value]="item.id">{{ item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Matricule chez garant :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Matricule chez garant" autocomplete="off"
                                    [(ngModel)]="itemToSave.matricule_chez_garant" name="matricule_chez_garant"
                                    autocomplete="off" type="text" />
                            </div>

                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Matricule chez souscripteur :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Matricule chez souscripteur" autocomplete="off"
                                    [(ngModel)]="itemToSave.matricule_chez_souscripteur"
                                    name="matricule_chez_souscripteur" autocomplete="off" type="text" />
                            </div>
                            <div *ngIf="itemToSave.id" class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Matricule:
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input disabled [disabled]="isAssurePrincipal || itemToSave.is_detail_mode"
                                    class="form-control custom-input" placeholder="Matricule " autocomplete="off"
                                    [(ngModel)]="itemToSave.matricule" name="matricule" autocomplete="off"
                                    type="text" />
                            </div>
                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Matricule assuré:
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input (input)="getItemsBeneficiaire()"
                                    [disabled]="isAssurePrincipal || itemToSave.is_detail_mode || itemToSave.id"
                                    class="form-control custom-input" placeholder="Matricule assuré" autocomplete="off"
                                    [(ngModel)]="itemToSave.matricule_assure" name="matricule_assure" autocomplete="off"
                                    type="text" />
                            </div>

                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Nom :
                                    <span class="required_champs">*</span>
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Nom" autocomplete="off" [(ngModel)]="itemToSave.nom" name="nom"
                                    autocomplete="off" type="text" />
                            </div>

                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Prénoms :
                                    <span class="required_champs">*</span>
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Prénoms" autocomplete="off" [(ngModel)]="itemToSave.prenom"
                                    name="prenom" autocomplete="off" type="text" />
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Civilité :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <ng-select [disabled]="itemToSave.is_detail_mode" [(ngModel)]="itemToSave.civilite_id"
                                    placeholder="Choisissez " name="civilite_id" id="civilite_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsCivilite" [value]="item.id">{{ item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                                <label>Date de naissance :
                                    <span class="required_champs">*</span>
                                </label>
                                <!-- <input
                          onkeydown="return false" -->
                                <!-- <input [disabled]="itemToSave.id" (bsValueChange)="getAge()" type="text" placeholder="Date de naissance" -->
                                <input [disabled]="itemToSave.id || itemToSave.is_detail_mode"
                                    (bsValueChange)="getAge()" type="text" placeholder="Date de naissance"
                                    autocomplete="off" class="form-control" bsDatepicker [bsConfig]="{
                            dateInputFormat: 'DD/MM/YYYY',
                            containerClass: 'theme-dark-blue'
                          }" [(ngModel)]="itemToSave.date_naissance" name="date_naissance" />
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Genre :
                                    <span class="required_champs">*</span>
                                </label>
                                <!-- <ng-select [disabled]="itemToSave.id" [(ngModel)]="itemToSave.genre_id" placeholder="Choisissez " name="genre_id" -->
                                <ng-select [disabled]="itemToSave.is_detail_mode" [(ngModel)]="itemToSave.genre_id"
                                    placeholder="Choisissez " name="genre_id" id="genre_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsGenre" [value]="item.id">{{ item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Statut :
                                    <span class="required_champs">*</span>
                                </label>
                                <!-- <ng-select [disabled]="itemToSave.id" (change)="onSelectStatut()" [(ngModel)]="itemToSave.statut_id" -->
                                <ng-select [disabled]="itemToSave.is_detail_mode" (change)="onSelectStatut()"
                                    [(ngModel)]="itemToSave.statut_id" placeholder="Choisissez " name="statut_id"
                                    id="statut_id" [multiple]="false" [closeOnSelect]="true">
                                    <ng-option [disabled]="item.codification=='A'&&isAutoFill"
                                        *ngFor="let item of itemsStatut" [value]="item.id">{{ item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Taille (cm) :
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Taille" autocomplete="off" [(ngModel)]="itemToSave.taille"
                                    name="taille" autocomplete="off" type="text" mask="separator" />
                            </div>
                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Poids (kg) :
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Poids" autocomplete="off" [(ngModel)]="itemToSave.poids" name="poids"
                                    autocomplete="off" type="text" mask="separator" />
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Groupe sanguin :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <ng-select [disabled]="itemToSave.is_detail_mode"
                                    [(ngModel)]="itemToSave.groupe_sanguin_id" placeholder="Choisissez "
                                    name="groupe_sanguin_id" id="groupe_sanguin_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsGroupeSanguin" [value]="item.id">{{
                                        item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>

                            <!-- <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">
        
                            <label>Matricule :
                            </label>
        
                            <input disabled class="form-control custom-input" placeholder="Matricule" autocomplete="off"
                                [(ngModel)]="itemToSave.matricule" name="matricule" autocomplete="off"
                                type="text" />
                        </div> -->



                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Numéro CNAM :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Numéro CNAM" autocomplete="off" [(ngModel)]="itemToSave.numero_cnam"
                                    name="numero_cnam" autocomplete="off" type="text" />
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Nature pièce :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <ng-select [disabled]="itemToSave.is_detail_mode"
                                    [(ngModel)]="itemToSave.nature_piece_id" placeholder="Choisissez "
                                    name="nature_piece_id" id="nature_piece_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsNaturePiece" [value]="item.id">{{ item?.libelle
                                        }}
                                    </ng-option>
                                </ng-select>
                            </div>

                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Numéro pièce :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Numéro pièce" autocomplete="off" [(ngModel)]="itemToSave.numero_piece"
                                    name="numero_piece" autocomplete="off" type="text" />
                            </div>




                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                                <label>Validité :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <input [disabled]="itemToSave.is_detail_mode" type="text" placeholder="Validité"
                                    autocomplete="off" class="form-control" bsDatepicker [bsConfig]="{
                            
                            containerClass: 'theme-dark-blue'
                          }" [(ngModel)]="itemToSave.validite_piece" name="validite_piece" />
                            </div>


                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Email :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Email" autocomplete="off" [(ngModel)]="itemToSave.email" name="email"
                                    autocomplete="off" type="email" />
                            </div>

                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Email 2 :
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Email2" autocomplete="off" [(ngModel)]="itemToSave.email2"
                                    name="email2" autocomplete="off" type="email" />
                            </div>
                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">

                                <label>Téléphone :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Téléphone" autocomplete="off" [(ngModel)]="itemToSave.telephone"
                                    name="telephone" autocomplete="off" type="text" mask="00-00-00-00-00" />
                            </div>
                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">
                                <label>Téléphone 2 :
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Téléphone 2" autocomplete="off" [(ngModel)]="itemToSave.telephone2"
                                    name="telephone2" autocomplete="off" type="text" mask="00-00-00-00-00" />
                            </div>



                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                                <label>Date entrée :
                                    <span class="required_champs">*</span>
                                </label>
                                <!-- <input
                          onkeydown="return false" -->
                                <input [disabled]="itemToSave.id || itemToSave.is_detail_mode" type="text"
                                    placeholder="Date de naissance" autocomplete="off" class="form-control" bsDatepicker
                                    [bsConfig]="{
                            dateInputFormat: 'DD/MM/YYYY',
                            containerClass: 'theme-dark-blue'
                          }" [(ngModel)]="itemToSave.date_entree" name="date_entree" />
                            </div>
                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">
                                <label>Délai de carence :
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" class="form-control custom-input"
                                    placeholder="Délai de carence" autocomplete="off"
                                    [(ngModel)]="itemToSave.delai_carence" name="delai_carence" autocomplete="off"
                                    type="text" mask="separator" />
                            </div>

                            <div style="position: relative;"
                                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Réseau de soin :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <ng-select [disabled]="itemToSave.is_detail_mode"
                                    [(ngModel)]="itemToSave.reseau_de_soin_id" placeholder="Choisissez "
                                    name="reseau_de_soin_id" id="reseau_de_soin_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsReseauDeSoin" [value]="item.id">{{
                                        item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div style="position: relative;"
                                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Tarif :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <ng-select [disabled]="itemToSave.is_detail_mode" [(ngModel)]="itemToSave.tarif_id"
                                    placeholder="Choisissez " name="tarif_id" id="tarif_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsTarif" [value]="item.id">{{
                                        item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="!itemToSave.id" style="position: relative;"
                                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Avenant :
                                    <span class="required_champs">*</span>
                                </label>
                                <ng-select [disabled]="itemToSave.is_detail_mode" [(ngModel)]="itemToSave.avenant_id"
                                    placeholder="Choisissez " name="avenant_id" id="avenant_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsAvenant" [value]="item.id">{{
                                        item?.libelle }}
                                    </ng-option>
                                </ng-select>

                                <button [disabled]="itemToSave.is_detail_mode" (click)="openAddAvenant()"
                                    class="btn btn-success" style="position: absolute;
                                        right: 0;
                                        top: 0;
                                        border-radius: 50px;
                                    "><i class="fa fa-plus"></i></button>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Type remboursement :
                                </label>
                                <ng-select [disabled]="itemToSave.is_detail_mode" (change)="onSelectTypeRemboursement()"
                                    [(ngModel)]="itemToSave.type_remboursement_id" placeholder="Choisissez "
                                    name="type_remboursement_id" id="type_remboursement_id" [multiple]="false"
                                    [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsTypeRemboursement" [value]="item.id">{{
                                        item?.libelle }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <!-- <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Taux tpg (%) :
                                    <span class="required_champs">*</span>
                                </label>

                                <input [disabled]="isDetailMode || itemToSave.is_detail_mode"
                                    class="form-control custom-input" placeholder="Taux tpg" autocomplete="off"
                                    [(ngModel)]="itemToSave.taux_tpg" name="taux_tpg" autocomplete="off" type="text"
                                    mask="separator" />

                            </div>
                            <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Majoration tpg (%) :
                                    <span class="required_champs">*</span>
                                </label>

                                <input [disabled]="isDetailMode || itemToSave.is_detail_mode"
                                    class="form-control custom-input" placeholder="Majoration tpg" autocomplete="off"
                                    [(ngModel)]="itemToSave.majoration_tpg" name="majoration_tpg" autocomplete="off"
                                    type="text" mask="separator" />

                            </div>
                            <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Plafond tpg (%) :
                                    <span class="required_champs">*</span>
                                </label>

                                <input [disabled]="isDetailMode || itemToSave.is_detail_mode"
                                    class="form-control custom-input" placeholder="Plafond tpg" autocomplete="off"
                                    [(ngModel)]="itemToSave.plafond_tpg" name="plafond_tpg" autocomplete="off"
                                    type="text" mask="separator" />

                            </div> -->
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                           <label>Codes affections(séparer par ;) :
                                </label>
                                <!-- <ng-select
                                    [disabled]="itemToSave.is_detail_mode"
                                    [multiple]="true"
                                    [ngModelOptions]="{standalone: true}"
                                    
                                    (change)="onSelectAffection()" [(ngModel)]="itemToSave.datasAffection"
                                    placeholder="Choisissez "
                                    [closeOnSelect]="true">
                                    <ng-option  *ngFor="let item of itemsAffection" [value]="item">{{ item?.libelle }}
                                    </ng-option>
                                </ng-select> -->
                                <textarea [(ngModel)]="itemToSave.affections" name="affections" class="form-control"></textarea>
                            </div>
                            <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">
                                <br>
                                <label>Vip? :
                                </label>

                                <input [disabled]="itemToSave.is_detail_mode" [(ngModel)]="itemToSave.is_vip"
                                    name="is_vip" autocomplete="off" type="checkbox" />


                            </div>



                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
                                <div class="row">
                                    <div class="col-md-12" style="text-align: center;">
                                        Age: <strong>{{getAge()}}</strong>
                                    </div>
                                </div>
                                <div class="row" style="padding: 0">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1 mt-2">
                                        <img src="{{
                              imageDisplay ||
                                'assets/images/custom/user-ano.jpeg'
                            }}" style="
                              width: 100%;
                              height: 200px;

                              display: block;
                            " />
                                        <input [disabled]="itemToSave.is_detail_mode" hidden id="img" type="file"
                                            class="custom-input form-control" (change)="uploadFile($event)"
                                            accept=".png, .jpg, .jpeg, .bmp" name="photo" />
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <label for="img" style="
                            width: 100%;
                            background-color: #0465aa;
                            padding: 5px;
                            cursor:pointer
                          ">
                                            <span style="color: white; padding: 5px">Choisir une image</span>
                                        </label>
                                    </div>
                                </div>
                                <!-- <hr> -->


                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <app-info-utile-benef [matricule_assure]="itemToSave.matricule_assure"></app-info-utile-benef>
                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <button type="button" (click)="confirmSaveItem(itemToSave)" class="btn btn-md custom_btn_primary pull-right"
            [class.auth-spinner]="loading" [disabled]="loading">
            Sauvegarder
        </button>

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>